import { AnalyticsService } from '../../typescript/common/analytics-service';
import './_line-name-boxed.scss';

(function timetableDetailsPage() {
  if (document.getElementsByClassName('timetable-details-page').length > 0) {
    class TimetableDetailsPage {
      public init() {
        const timetableLinks = document.getElementsByClassName('timetable-link');
        if (timetableLinks.length > 0) {
            const lineName = document.querySelector('.timetable-details-page')?.getAttribute('data-line-name');
            Array.from(timetableLinks).forEach((link) => {
                link.addEventListener('click', () => {
                AnalyticsService.addEvent(AnalyticsService.Timetables, 'Klick på tidtabellslänk', lineName ?? '');
                });
            });
        }
      }
    }
    const page = new TimetableDetailsPage();
    page.init();
  }
})();